/**
 * Return an empty list.
 *
 * @return {null} The empty list.
 */
export default function empty() {
	return null;
}
